<SidebarShell :logo="short_logo" :brand_title="brand_name" :brand_subtitle="brand_subtitle" :initials="initials"
  :full_name="full_name">
  <!-- ✅ FORWARD SIDEBAR HEADER ACTIONS (X BUTTON) -->
  <template #sidebar-header-actions>
    <slot name="sidebar-header-actions"></slot>
  </template>

  <!-- MENU -->
  <template #menu>
    <div class="px-3 mt-3">
      <!-- ✅ MENU LIST -->
      <template v-for="item in menuItems" :key="item.key">

        <!-- ✅ SECTION HEADER (Previously Accordion) -->
        <div v-if="item.type === 'section' || item.type === 'accordion'" class="mt-2">

          <!-- section header (becomes a thin divider on the collapsed rail) -->
          <div class="d-flex align-items-center gap-2 sidebar-section-header"
            :class="{ active: is_section_active(item) }">
            <i :class="item.icon" aria-hidden="true"></i>
            <span class="sidebar-menu-text">{{ item.label }}</span>
          </div>

          <!-- section body (indent is dropped on the rail so every icon lines up) -->
          <div class="sidebar-section-body ps-2 mt-2">
            <div v-for="child in item.children" :key="child.key"
              class="d-flex align-items-center gap-2 px-2 py-2 rounded-3 sidebar-menu-item"
              :class="{ active: active_menu_item === child.key }" role="button" tabindex="0"
              :aria-label="child.label" :title="is_sidebar_collapsed() ? child.label : null"
              @click.stop="select_menu_item(child.key, child.label)"
              @keydown.enter.prevent="select_menu_item(child.key, child.label)"
              @keydown.space.prevent="select_menu_item(child.key, child.label)">
              <i :class="child.icon" aria-hidden="true"></i>
              <span class="text-xs sidebar-menu-text">{{ child.label }}</span>
            </div>
          </div>

        </div>

        <!-- ✅ NORMAL MENU ITEM -->
        <div v-else class="d-flex align-items-center gap-2 px-2 py-2 rounded-3 sidebar-menu-item"
          :class="{ active: active_menu_item === item.key }" role="button" tabindex="0"
          :aria-label="item.label" :title="is_sidebar_collapsed() ? item.label : null"
          @click="select_menu_item(item.key, item.label)"
          @keydown.enter.prevent="select_menu_item(item.key, item.label)"
          @keydown.space.prevent="select_menu_item(item.key, item.label)">
          <i :class="item.icon" aria-hidden="true"></i>
          <span class="text-xs sidebar-menu-text">{{ item.label }}</span>
        </div>

      </template>
    </div>
  </template>

  <template #footer-actions>
    <ProbaRedirectButton />
  </template>
</SidebarShell>
